import React, { Component } from "react";

import {
  Container,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { GetData } from "../../api/service";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

export default class FormerVolunteer extends Component {
  state = {
    data: [],
    isLoaded: false,
  };

  componentDidMount() {
    GetData(`/getformervolunteers`).then((resp) => {
      this.setState({
        data: Array.isArray(resp) ? resp : [],
        isLoaded: true,
      });
    });
  }

  // Group the flat list into year-wise sections, preserving the backend order
  // (year DESC, then serial number within the year).
  __groupByYear = () => {
    const groups = {};
    const order = [];
    (this.state.data || []).forEach((el) => {
      const y = el.year || "Unspecified";
      if (!groups[y]) {
        groups[y] = [];
        order.push(y);
      }
      groups[y].push(el);
    });
    return order.map((y) => ({ year: y, rows: groups[y] }));
  };

  __photoUrl = (el) => {
    if (Array.isArray(el.photo) && el.photo.length > 0) {
      return el.photo[0].url || "";
    }
    return "";
  };

  render() {
    const groups = this.__groupByYear();

    return (
      <div>
        <BreadCrumbOwn title="Former Volunteers" />

        <Container className="mb-5">
          <br />

          <Typography
            variant="h5"
            style={{ margin: "1em 0", fontWeight: 700 }}
            gutterBottom
          >
            Former Volunteers
          </Typography>

          <br />

          {this.state.isLoaded && groups.length === 0 && (
            <Typography variant="body1">
              No former volunteers to display yet.
            </Typography>
          )}

          {this.state.isLoaded &&
            groups.map(({ year, rows }) => (
              <div key={year} style={{ marginBottom: 30 }}>
                <Typography
                  variant="h6"
                  style={{ fontWeight: 700, color: "#0B3D2E", marginBottom: 8 }}
                >
                  {year}
                </Typography>

                <div style={{ overflowX: "auto" }}>
                  <Table className="table table-sm table-striped table-bordered">
                    <TableHead>
                      <TableRow>
                        <TableCell>Sl. No.</TableCell>
                        <TableCell>Photo</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Rank</TableCell>
                        <TableCell>Date of Enrolling</TableCell>
                        <TableCell>Date of Exit / Completion</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((el, index) => (
                        <TableRow key={el.id}>
                          <TableCell>{el.order_no || index + 1}</TableCell>
                          <TableCell>
                            {this.__photoUrl(el) ? (
                              <img
                                src={this.__photoUrl(el)}
                                alt={el.name}
                                style={{
                                  width: 55,
                                  height: 55,
                                  objectFit: "cover",
                                  borderRadius: 6,
                                }}
                              />
                            ) : null}
                          </TableCell>
                          <TableCell>{el.name}</TableCell>
                          <TableCell>{el.rank}</TableCell>
                          <TableCell>{el.date_of_enrolling}</TableCell>
                          <TableCell>{el.date_of_exit}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            ))}
        </Container>
      </div>
    );
  }
}
